export default __webpack_public_path__ + "43660f6100feb211b6897a1e25a876c9.svg";